/* eslint-disable @typescript-eslint/no-explicit-any */
import { useToast } from "@/hooks";
import { endpoints } from "../endpoints";
import { patchResource, postResource, updateResource } from "../https";
import { AddressFormData,    ContactUs, Delete, UpdatePassword, UpdateProfile, UserRating } from "../types";
import { useMutation } from "@tanstack/react-query";
import { useGetAddresses } from "../queries";

export const addOrEditAddress = (payload: AddressFormData) => {
  return postResource({ pathUrl: `${endpoints.addresses}`, payload });
};

export const contactUs = (payload: ContactUs) => {
  return postResource({ pathUrl: `${endpoints.contact}`, payload });
};

export const userRating = (payload: UserRating) => {
  return postResource({ pathUrl: `${endpoints.user}/ratings`, payload });
};

export const updateUserProfile = (payload: UpdateProfile) => {
  return updateResource({ pathUrl: `${endpoints.user}`, payload });
};

export const updatePassword = (payload: UpdatePassword) => {
  return patchResource({ 
    pathUrl: `${endpoints.updatePassword}`, 
    payload,
    skipAuthLogout: true 
  });
};


export const deleteAddress = (payload: Delete) => {
  return updateResource({ pathUrl: `${endpoints.addresses}/${payload}` });
};

export const useAddOrEditAddress = () => {
  const { toast } = useToast();
  const { refetch } = useGetAddresses();

  return useMutation({
    mutationFn: (payload: AddressFormData) => addOrEditAddress(payload),
    onSuccess: async (data) => {
      toast({
        title: "Success",
        description: `${data.message}`,
      });
      refetch()
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};

export const useContactUs = () => {
  const { toast } = useToast();
  return useMutation({
    mutationFn: (payload: ContactUs) => contactUs(payload),
    onSuccess: async (data) => {
      toast({
        title: "Success",
        description: `${data.message}`,
      });
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};

export const useUserRating = () => {
  const { toast } = useToast();
  return useMutation({
    mutationFn: (payload: UserRating) => userRating(payload),
    onSuccess: async (data) => {
      toast({
        title: "Success",
        description: `${data.message}`,
      });
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};

export const useUpdateUserProfile = () => {
  const { toast } = useToast();
  return useMutation({
    mutationFn: (payload: UpdateProfile) => updateUserProfile(payload),
    onSuccess: async (data) => {
      toast({
        title: "Success",
        description: `${data.message}`,
      });
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};

export const useUpdatePassword = () => {
  const { toast } = useToast();
  return useMutation({
    mutationFn: (payload: UpdatePassword) => updatePassword(payload),
    onSuccess: async (data) => {
      toast({
        title: "Success",
        description: `${data.message}`,
      });
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};

export const useDeleteAddress = () => {
  const { toast } = useToast();
  return useMutation({
    mutationFn: (payload: Delete) => deleteAddress(payload),
    onSuccess: (data) => {
      toast({
        title: "Success",
        description: `${data.message}`,
      });
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};
